import { Box, Divider, Typography, useTheme } from "@mui/material";
import type { ReactNode } from "react";

interface BreakdownMenuItemProps {
  label: string;
  value: string;
  icon?: ReactNode;
  isActive: boolean;
  onClick: (value: string) => void;
  isSecondary?: boolean;
  disabled?: boolean;
}

const BreakdownMenuItem = ({
  label,
  value,
  icon,
  isActive,
  onClick,
  isSecondary = false,
  disabled = false,
}: BreakdownMenuItemProps) => {
  const theme = useTheme();

  return (
    <Box
      width="90%"
      onClick={() => !disabled && onClick(value)}
      sx={{
        cursor: disabled ? "not-allowed" : "pointer",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: disabled ? "inherit" : theme.palette.grey[300],
        },
        "&:active": {
          transform: disabled ? "none" : "scale(0.98)",
          backgroundColor: disabled ? "inherit" : theme.palette.grey[400],
        },
      }}
    >
      <Typography
        fontSize="1.1rem"
        fontWeight={500}
        color={
          isActive
            ? isSecondary
              ? theme.palette.secondary.main
              : theme.palette.primary.main
            : isSecondary
              ? theme.palette.grey[500]
              : theme.palette.grey[600]
        }
        textAlign="left"
        display="flex"
        alignItems="center"
        gap={0.5}
        sx={{
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        {icon} {label}
      </Typography>
      <Divider
        sx={{
          my: 1,
          borderColor: isActive
            ? isSecondary
              ? theme.palette.secondary.main
              : theme.palette.primary.main
            : theme.palette.grey[100],
        }}
      />
    </Box>
  );
};

export default BreakdownMenuItem;
